import { FcGeneratorOptions, FcShape } from '@dtx-company/flowcode-generator-types'

export function getFrameOptions(props: {
  hasRimText?: boolean
  showFrame?: boolean
  selectedShape?: FcShape
  dataPatternColor: string
  backgroundColor?: string
}): FcGeneratorOptions {
  const { selectedShape, showFrame, dataPatternColor, backgroundColor } = props
  const isCircle = selectedShape === FcShape.CIRCLE
  if (showFrame) {
    if (isCircle) {
      return {
        dataGridPercentageSize: 70,
        containerImageOverlayPrivacy: false,
        containerRimWidth: 22,
        containerRimBorderSize: 1,
        containerBorderSize: 1,
        // with low scannable colors, white would appear as a thin line so we use background color to blend it
        containerBorderColor: backgroundColor ?? '#FFF',
        containerEmptySpaceSize: 6,
        containerImageUrl: undefined
      }
    } else {
      return {
        dataGridPercentageSize: 94,
        containerImageOverlayPrivacy: false,
        containerOuterPatternColorFillSvg: false,
        containerOuterPatternRandomSizes: '0',
        containerImageUrl: undefined,
        containerRimWidth: 15,
        containerRimBorderSize: 8,
        containerBorderColor: dataPatternColor,
        containerBorderSize: 8.5,
        containerEmptySpaceSize: 6,
        logoOuterPadding: 2
      }
    }
  } else {
    return {
      dataGridPercentageSize: isCircle ? 69 : 90,
      containerEmptySpaceSize: isCircle ? 6 : 12,
      containerRimBackgroundColor: undefined,
      containerRimBorderSize: undefined,
      containerBorderSize: 8.5
    }
  }
}
